import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse
} from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable, throwError } from "rxjs";
import { tap, catchError } from "rxjs/operators";
import { SnackbarService } from "../../services/home/snackbar.service";

const SUCCESS_KEY_CODE: number = 200;
const BAD_REQUEST_KEY_CODE: number = 400;
const NOT_FOUND_KEY_CODE: number = 404;
const USERNAME_NOT_FOUND_KEY_CODE: number = 410;
const PASSWORD_NOT_CORRECT_KEY_CODE: number = 411;
const USER_NOT_ACTIVE_KEY_CODE: number = 412;
const USER_SUSPEND_KEY_CODE: number = 413;
const USER_NAME_TAKEN_KEY_CODE: number = 414;
const NOT_AUTHORIZED_KEY_CODE: number = 415;
const PASSWORD_STRENGTH_KEY_CODE: number = 416;
const TOKEN_NOT_FOUND_KEY_CODE: number = 417;
const NOT_ALLOWED_TO_DO_ACTION_KEY_CODE: number = 418;
const ERROR_KEY_CODE: number = 500;
const UN_AUTHORIZED_KEY_CODE: number = 401;

@Injectable({
  providedIn: "root"
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private router: Router, private snackBar: SnackbarService) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.router.url == "/login") {
      // Basically Do Nothing
      return next.handle(req.clone({
        setHeaders: {
          'Accept-Language': localStorage.getItem('language')||'ar',
        },
      }));
    } else {
      let rawUrl: string;
      !req.url.includes("#") ? (rawUrl = req.url + "#") : (rawUrl = req.url);
      const splitedURL = rawUrl.split("#");
      // Get Actual URL
      const URL: string = splitedURL[0];
      // Get POST Toastr Successed MSG
      const postMsg: string = splitedURL[1];
      let clonedReq: HttpRequest<any>;
      // Exclude Languages GET API Only
      if (URL.includes("LanguagesManagement") && req.method?.toLowerCase() === "get") {
        clonedReq = req.clone({
          url: URL
        });
      } else {
        clonedReq = req.clone({
          setHeaders: {
            'responseType': 'arraybuffer',
            'Accept-Language': localStorage.getItem('language')||'ar',
            Authorization:"Bearer "+sessionStorage.getItem("TOKEN"),
          },
          url: URL
        });
      }
      return next.handle(clonedReq).pipe(
        tap(res => {
         
          if (res instanceof HttpResponse) {

            if (res.status == SUCCESS_KEY_CODE) {
              if (
                clonedReq.method?.toLowerCase() === "post" ||
                clonedReq.method?.toLowerCase() === "put" ||
                clonedReq.method?.toLowerCase() === "delete"
              ) {
                // To Avoid empty toastrs in some PUT, POST reqs
                if (postMsg.length != 0) {
                  this.snackBar.openSnackBar(postMsg, "", "Success");
                }
              }
            } else {
              // Call Switch function here
              if(res.status==BAD_REQUEST_KEY_CODE)
              this.responseStatusCodeResult(res.status,res.body.msg);
              else
              this.responseStatusCodeResult(res.status);
              throw throwError(false);
            }
          }else{
          /*  console.log(res)
            let url = window.URL.createObjectURL(res);
            let a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = '';
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove();
          */}

        }),
        catchError(err => {
          if (err instanceof HttpErrorResponse) {
            try {
              //  this.responseStatusCodeResult(err.status);
              switch (err.status) {
                case UN_AUTHORIZED_KEY_CODE:
                  console.log("un authorized")
                  this.snackBar.openSnackBar("un authorized", "", "Error");
                  this.router.navigate(['/login'])
                  break;
                default:
                  if(Array.isArray(err.error?.messages) && err.error.messages.length >0){
                    err.error.messages.forEach(item=>{
                      this.snackBar.openSnackBar(item, "", "Error");
                    })
                  }
                  break;
              }
                // console.log(err);
                //this.snackBar.openSnackBar("An Error Has Occurred", "", "Error");
              } catch (e) {
                // console.log("Http Error Catch,");
              }
            }
          return throwError("Http Error Interpreted");
          })
      );
    }
  };

  responseStatusCodeResult(resCode: number,msg?:string): void {
    switch (resCode) {
      case UN_AUTHORIZED_KEY_CODE:
        console.log("un authorized")
        this.snackBar.openSnackBar("un authorized", "", "Error");
        this.router.navigate(['/login'])
        break;
      case BAD_REQUEST_KEY_CODE:
        if (msg && msg.includes("24 hours")) {
          msg = "Your account has been locked, please try again after 24 hours";
        }
        msg ?  this.snackBar.openSnackBar(msg, "", "Error") : this.snackBar.openSnackBar("Bad Request", "", "Error")
        break;
      case NOT_FOUND_KEY_CODE:
        this.snackBar.openSnackBar("Request Not Found", "", "Error");
        break;
      case USERNAME_NOT_FOUND_KEY_CODE:
        this.snackBar.openSnackBar("Username Not Found", "", "Error");
        break;
      case PASSWORD_NOT_CORRECT_KEY_CODE:
        this.snackBar.openSnackBar("Password Not Correct", "", "Error");
        break;
      case USER_NOT_ACTIVE_KEY_CODE:
        this.snackBar.openSnackBar("This User Is Not Active", "", "Error");
        break;
      case USER_SUSPEND_KEY_CODE:
        this.snackBar.openSnackBar("This User Is Suspended", "", "Error");
        break;
      case USER_NAME_TAKEN_KEY_CODE:
        this.snackBar.openSnackBar("This User Name Already Taken", "", "Error");
        break;
      case NOT_AUTHORIZED_KEY_CODE:
        this.snackBar.openSnackBar("This User Is Not Authorized", "", "Error");
        break;
      case PASSWORD_STRENGTH_KEY_CODE:
        this.snackBar.openSnackBar("Weak Password Strength", "", "Error");
        break;
      case TOKEN_NOT_FOUND_KEY_CODE:
        this.snackBar.openSnackBar("User TOKEN Not Found", "", "Error");
        break;
      case NOT_ALLOWED_TO_DO_ACTION_KEY_CODE:
        this.snackBar.openSnackBar("Action Is Not Allowed", "", "Error");
        break;
      case ERROR_KEY_CODE:
        this.snackBar.openSnackBar("Server Error", "", "Error");
        break;
      default:
        // console.log("Current Request Code:" + resCode);
        break;
    }
  }

}
